import React, { createContext } from 'react'
import { useQuery } from '@apollo/client'
import { CURRENT_USER_QUERY } from '../graphql/User'
import CentredLoader from '../components/CentredLoader'

export const CurrentUserContext = createContext({} as any)

const CurrentUserContextProvider = (props: any) => {
  const { data: userData, loading } = useQuery(CURRENT_USER_QUERY)

  const currentUser = userData?.currentUser

  if (loading) {
    return <CentredLoader />
  }

  return (
    <CurrentUserContext.Provider value={currentUser}>
      {props.children}
    </CurrentUserContext.Provider>
  )
}

export default CurrentUserContextProvider
